const meta = {
  rollup: 'Rollup rules',
  recording: 'Recording rules',
  mapping: 'Mapping rules',
  'drop-rules': 'Drop rules',
  'evaluation-failures': 'Evaluation failures',
};

export default meta;
